import { createContext } from 'react';
import { GenericAccordionProps } from '@primitives/Accordion/types';

export const AccordionGroupContext = createContext<GenericAccordionProps>({});
